export default "__VITE_ASSET__CMqei4iC__"